import React from "react";
import "./QuestionModal.css";

const QuestionModal = ({ 
    isOpen, 
    onClose, 
    title = "Confirmation", 
    message = "Are you sure?", 
    onConfirm, 
    confirmLabel = "Yes", 
    cancelLabel = "No" 
}) => {
    if (!isOpen) return null;

    return (
        <div className="question-modal-overlay">
            <div className="question-modal-content">
                <h2>{title}</h2>
                <p>{message}</p>
                <div className="question-modal-buttons">
                    <button className="question-confirm-btn" onClick={onConfirm}>{confirmLabel}</button>
                    <button className="question-cancel-btn" onClick={onClose}>{cancelLabel}</button>
                </div>
            </div>
        </div>
    );
};

export default QuestionModal;
